import React from "react";
import '../../style_new.css';

const factsData = [
  {
    id: "01",
    title: "Construction",
    image: "./images/fact-1.jpg",
    description:
      "Our team ensures every structure is built with precision, strength, and long-lasting quality.",
    delay: "0.1s"
  },
  {
    id: "02",
    title: "Mechanical",
    image: "./images/fact-2.jpg",
    description:
      "We design and implement advanced mechanical systems that improve functionality and reliability across all projects.",
    delay: "0.3s"
  },
  {
    id: "03",
    title: "Architecture",
    image: "./images/fact-3.jpg",
    description:
      "Our architects blend creativity with functionality to deliver stunning designs that inspire and endure.",
    delay: "0.5s"
  },
  {
    id: "04",
    title: "Interior Design",
    image: "./images/fact-4.jpg",
    description:
      "From concept to execution, our interior designs reflect style, comfort, and exceptional attention to detail.",
    delay: "0.7s"
  }
];

const Facts = () => {
  return (
    <>
      {/* facts section start */}
      <div className="container-fluid my-5 p-0">
        <div className="row g-0">
          {factsData.map(({ id, title, image, description, delay }) => (
            <div
              key={id}
              className="col-xl-3 col-sm-6 wow fadeIn"
              data-wow-delay={delay}
            >
              <div className="position-relative">
                <img className="img-fluid w-100" src={image} alt={title} />
                <div className="facts-overlay">
                  <h1 className="display-1">{id}</h1>
                  <h4 className="text-white mb-3">{title}</h4>
                  <p className="text-white">{description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* facts section end */}
    </>
  );
};

export default Facts;
